import { Controller } from "@hotwired/stimulus"

// Clips long content to a collapsed height with a gradient fade and a
// "See more" toggle, so a long list (e.g. the triage table) doesn't expand to
// take over the page. Expanding reveals the full content and hides the fade.
//
// Reusable: the collapsed height is a Stimulus value taking any CSS height
// (e.g. "18rem", "300px", "40vh") with a sane default, so no height is
// hardcoded per usage.
//
// data-controller="see-more"
//   content -> the clipped region
//   fade    -> the gradient overlay (hidden when expanded)
//   button  -> the toggle, with data-see-more-more-label-value / less-label-value
export default class extends Controller {
  static targets = ["content", "fade", "button"]
  static values = {
    expanded: { type: Boolean, default: false },
    maxHeight: { type: String, default: "18rem" },
    moreLabel: { type: String, default: "See more" },
    lessLabel: { type: String, default: "See less" }
  }

  connect() {
    this.collapse()
  }

  toggle() {
    this.expandedValue ? this.collapse() : this.expand()
  }

  expand() {
    this.expandedValue = true
    this.contentTarget.style.maxHeight = ""
    this.contentTarget.style.overflowY = ""
    if (this.hasFadeTarget) this.fadeTarget.classList.add("hidden")
    if (this.hasButtonTarget) this.buttonTarget.textContent = this.lessLabelValue
  }

  collapse() {
    this.expandedValue = false
    this.contentTarget.style.maxHeight = this.maxHeightValue
    this.contentTarget.style.overflowY = "hidden"
    if (this.hasFadeTarget) this.fadeTarget.classList.remove("hidden")
    if (this.hasButtonTarget) this.buttonTarget.textContent = this.moreLabelValue
  }
}
